import { styled } from "styled-components";
import { borderRadius } from "polished";
const CardsWrapper = styled("ul")(
  {
    display: "grid",
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative",
    transform: "translateZ(0)"
  },
  ({ grow }) => ({
    justifyContent: grow ? "stretch" : "center"
  }),
  ({ grow, view }) => ({
    grid: {
      gap: 16,
      gridTemplateColumns: `repeat(auto-fill, ${grow ? "minmax(304px, 1fr)" : "304px"})`,
      "@supports (grid-template-columns: repeat(auto-fill, min(304px, 100%)))": {
        gridTemplateColumns: `repeat(auto-fill, ${grow ? "minmax(min(304px, 100%), 1fr)" : "min(304px, 100%)"})`
      }
    },
    list: {
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
      gridTemplateColumns: "100%"
    }
  })[view]
);
const CardsItem = styled("li")(
  {
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative",
    "&:focus-within": {
      zIndex: 1
    },
    "&:hover": {
      zIndex: 2
    }
  },
  ({ view }) => ({
    grid: {
      borderRadius: 2,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
    },
    list: {
      borderRadius: "inherit",
      marginTop: -1,
      "&:first-child": {
        ...borderRadius("top", 2),
        marginTop: 0
      },
      "&:last-child": {
        ...borderRadius("bottom", 2)
      }
    }
  })[view]
);
const CardsFooter = styled("li").attrs({
  role: "contentinfo"
})(({ theme }) => ({
  color: theme.color.black6,
  gridColumn: "1 / -1",
  marginTop: "auto"
}));
export {
  CardsFooter,
  CardsItem,
  CardsWrapper
};
